// import { orthodoxEaster } from 'date-easter';
import { avatarEndpoints } from '@libs/shared/src/common/constants';
import moment from 'moment';
import { GameScene } from 'src/ts/classes/GameScene';

import { ButtonsAssets, GameAssets, IconAssets, ImageAssets } from '../enums/assets';
import { SeasonEnum } from '../enums/season';

const date = (dayMonth: string) => {
  return moment(`${dayMonth}-${moment().year()}`, 'DD MM YYYY');
};

const userBirthday = (userDate: string) => {
  const m = moment(userDate);
  return date(`${m.date()}-${m.month() + 1}`);
};

export const isTodayUserBirthday = (context: GameScene) =>
  userBirthday(context.user.user.birthDate as string).isSame(moment(), 'day');

// const easter = orthodoxEaster(moment().year());

export const dates = {
  programmers: moment().startOf('year').add(256, 'days'),
};

// TODO:
// birthday custom icon (date)

const path = './assets/levels/';

enum IconsPath {
  homeBlack = './assets/icons/home.svg',
  homeWhite = './assets/icons/home-white.svg',
  scaleBlack = './assets/icons/scale-out.svg',
  scaleWhite = './assets/icons/scale-out-white.svg',
}

export const loadGameAssets = (context: GameScene) => {
  let bgPath = '';
  let homeIconPath: string = IconsPath.homeBlack;
  let scaleOutIconPath: string = IconsPath.scaleBlack;
  let coinPath = 'standard/coin.svg';
  const lifePath = 'valentino/heart.svg';
  let foePath = 'standard/mushroom.svg';
  let playerDefaultPath = 'standard/sloth.png';
  let playerHappyPath = 'standard/sloth-happy.svg';
  let playerDeadPath = 'standard/sloth-dead.svg';

  const season = context.user.seasons.seasonName as SeasonEnum;

  const seasonAssets: Record<
    SeasonEnum,
    {
      bg: string;
      coin: string;
      foe: string;
      player: string;
      happy: string;
      dead: string;
      homeIcon?: string;
      scaleIcon?: string;
    }
  > = {
    [SeasonEnum.SPRING]: {
      bg: 'spring/Spring_bg.png',
      coin: 'spring/flower.svg',
      foe: 'spring/bee.svg',
      player: 'spring/sloth-default.svg',
      happy: 'spring/sloth-happy.svg',
      dead: 'spring/sloth-dead.svg',
    },
    [SeasonEnum.SUMMER]: {
      bg: 'summer/Summer_bg.png',
      coin: 'summer/watermelon.svg',
      foe: 'summer/shell.svg',
      player: 'summer/sloth-default.svg',
      happy: 'summer/sloth-happy.svg',
      dead: 'summer/sloth-dead.svg',
    },
    [SeasonEnum.AUTUMN]: {
      bg: 'autumn/Autumn_bg.png',
      coin: 'autumn/leaf.svg',
      foe: 'autumn/waterdrop.svg',
      player: 'autumn/sloth-default.svg',
      happy: 'autumn/sloth-happy.svg',
      dead: 'autumn/sloth-dead.svg',
    },
    [SeasonEnum.WINTER]: {
      bg: 'winter/Winter_bg.png',
      coin: 'winter/gingerbread.svg',
      foe: 'winter/icicle.svg',
      player: 'winter/sloth-default.svg',
      happy: 'winter/sloth-happy.svg',
      dead: 'winter/sloth-dead.svg',
    },
    [SeasonEnum.HALLOWEEN]: {
      bg: 'halloween/Halloween_bg.png',
      coin: 'halloween/pumpkin.svg',
      foe: 'halloween/ghost.svg',
      player: 'halloween/sloth-default.svg',
      happy: 'halloween/sloth-happy.svg',
      dead: 'halloween/sloth-dead.svg',
      homeIcon: IconsPath.homeWhite,
      scaleIcon: IconsPath.scaleWhite,
    },
    [SeasonEnum.VALENTINO]: {
      bg: 'valentino/Valentines_Day_bg.png',
      coin: 'valentino/heart.svg',
      foe: 'valentino/arrow.svg',
      player: 'valentino/sloth-default.svg',
      happy: 'valentino/sloth-happy.svg',
      dead: 'valentino/sloth-dead.svg',
    },
    [SeasonEnum.CHRISTMAS]: {
      bg: 'christmas/Christmas_bg.png',
      coin: 'christmas/gift.svg',
      foe: 'christmas/ball.svg',
      player: 'christmas/sloth-default.svg',
      happy: 'christmas/sloth-happy.svg',
      dead: 'christmas/sloth-dead.svg',
    },
    [SeasonEnum.PROGRAMMERS]: {
      bg: 'programmers/Programmers_Day_bg.png',
      coin: 'programmers/money.svg',
      foe: 'programmers/fire.svg',
      player: 'programmers/sloth-default.svg',
      happy: 'programmers/sloth-happy.svg',
      dead: 'programmers/sloth-dead.svg',
      homeIcon: IconsPath.homeWhite,
      scaleIcon: IconsPath.scaleWhite,
    },
    [SeasonEnum.EASTER]: {
      bg: 'spring/Spring_bg.png',
      coin: 'easter/egg.svg',
      foe: 'easter/rabbit.svg',
      player: 'easter/sloth-default.svg',
      happy: 'easter/sloth-happy.svg',
      dead: 'easter/sloth-dead.svg',
    },
    [SeasonEnum.COMPANY_BIRTHDAY]: {
      bg: 'company-birthday/Company_Birthday_bg.svg',
      coin: 'company-birthday/cake.svg',
      foe: 'company-birthday/age.svg',
      player: 'company-birthday/sloth-default.svg',
      happy: 'company-birthday/sloth-happy.svg',
      dead: 'company-birthday/sloth-dead.svg',
    },
  };

  if (seasonAssets[season]) {
    const assets = seasonAssets[season];
    bgPath = assets.bg;
    coinPath = assets.coin;
    foePath = assets.foe;
    playerDefaultPath = assets.player;
    playerHappyPath = assets.happy;
    playerDeadPath = assets.dead;
    homeIconPath = assets.homeIcon || homeIconPath;
    scaleOutIconPath = assets.scaleIcon || scaleOutIconPath;
  }

  const isUserBdayToday = isTodayUserBirthday(context);
  if (isUserBdayToday) {
    bgPath = 'birthday/Birthday_bg.png';

    coinPath = 'birthday/cake.svg';
    foePath = 'birthday/age.svg';

    playerDefaultPath = 'birthday/sloth-default.svg';
    playerHappyPath = 'birthday/sloth-happy.svg';
    playerDeadPath = 'birthday/sloth-dead.svg';
  }
  // load
  context.load.svg(IconAssets.RESET_ICON, './assets/icons/reset.svg');
  context.load.svg(IconAssets.HOME_ICON, homeIconPath);
  context.load.svg(IconAssets.SCALE_OUT_ICON, scaleOutIconPath);
  context.load.svg(IconAssets.SOUND_ICON, './assets/icons/sound-on-music.svg');
  context.load.svg(IconAssets.MUTE_SOUND_ICON, './assets/icons/sound-off-music.svg');

  context.load.image(ImageAssets.BACKGROUND, `${path}${bgPath}`);

  context.load.image(GameAssets.COIN, `${path}${coinPath}`);
  context.load.image(GameAssets.LIFE, `${path}${lifePath}`);

  if (context.user.seasons.seasonName === SeasonEnum.COMPANY_BIRTHDAY) {
    context.user.avatars?.forEach((avatar: string) => {
      context.load.image(
        `avatar_${avatar}`,
        `${process.env.NEXT_PUBLIC_MARKET_API_URL}${avatarEndpoints.avatar}/${avatar}`
      );
    });
  }

  if (!isUserBdayToday) {
    context.load.image(GameAssets.FOE, `${path}${foePath}`);
  }

  context.load.image(GameAssets.PLAYER_DEFAULT, `${path}${playerDefaultPath}`);
  context.load.image(GameAssets.PLAYER_HAPPY, `${path}${playerHappyPath}`);
  context.load.image(GameAssets.PLAYER_DEAD, `${path}${playerDeadPath}`);

  context.load.svg(ButtonsAssets.YELLOW_DEFAULT_BTN, './assets/buttons/play/play-default-lg.svg');
  context.load.svg(ButtonsAssets.YELLOW_HOVER_BTN, './assets/buttons/play/play-hover-lg.svg');
  context.load.svg(ButtonsAssets.YELLOW_ACTIVE_BTN, './assets/buttons/play/play-active-lg.svg');

  context.load.svg(ButtonsAssets.GREEN_DEFAULT_BTN, './assets/buttons/score/score-default-lg.svg');
  context.load.svg(ButtonsAssets.GREEN_HOVER_BTN, './assets/buttons/score/score-hover-lg.svg');
  context.load.svg(ButtonsAssets.GREEN_ACTIVE_BTN, './assets/buttons/score/score-active-lg.svg');

  context.load.svg(ButtonsAssets.RED_DEFAULT_BTN, './assets/buttons/exit/exit-default-lg.svg');
  context.load.svg(ButtonsAssets.RED_HOVER_BTN, './assets/buttons/exit/exit-hover-lg.svg');
  context.load.svg(ButtonsAssets.RED_ACTIVE_BTN, './assets/buttons/exit/exit-active-lg.svg');

  context.load.image(IconAssets.AVATAR_ICON, './assets/icons/avatar-sample.png');
};
